module.exports = __webpack_public_path__ + "static/media/DogBearGames.ddce7509.png";